import { digitGroup, commonDate } from 'src/helpers'

const renderPercentage = (value) => {
  return value ? digitGroup(value) + '%' : '-'
}

const renderUser = (value) => {
  return `
  <div class="flex items-center gap-2">
    <img src="${require('src/assets/images/icons/16x16-users.svg')}" alt="" />
    ${value}
  </div>`
}

export const profitTargetCategory3Table = {
  visibleColumns: ['name', 'gross_profit', 'margin_retail', 'margin_business'],

  columns: [
    {
      name: 'name',
      field: (row) =>
        `<div>
          ${row.name}
          ${
            row.is_waiting_approval
              ? '<span class="custom-badge-blue dense q-ml-sm">Belum Disetujui</span>'
              : ''
          }
        </div>`,
      label: 'Kategori 3',
      sortable: true,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'gross_profit',
      field: (row) => renderPercentage(row.gross_profit),
      label: 'GP',
      sortable: true,
      align: 'right',
      rowClass: 'text-right text-weight-medium vertical-middle'
    },
    {
      name: 'margin_retail',
      field: (row) => renderPercentage(row.margin_retail),
      label: 'Margin Retail',
      sortable: true,
      align: 'right',
      rowClass: 'text-right text-weight-medium vertical-middle'
    },
    {
      name: 'margin_business',
      field: (row) => renderPercentage(row.margin_business),
      label: 'Margin Bisnis',
      sortable: true,
      align: 'right',
      rowClass: 'text-right text-weight-medium vertical-middle'
    }
  ]
}

export const profitTargetBrandTable = {
  visibleColumns: ['name', 'gross_profit'],

  columns: [
    {
      name: 'name',
      field: (row) =>
        `<div>
          ${row.name}
          ${
            row.status === 'WAITING'
              ? '<span class="custom-badge-blue dense q-ml-sm">Belum Disetujui</span>'
              : ''
          }
        </div>`,
      label: 'Merek',
      sortable: true,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'gross_profit',
      field: (row) => renderPercentage(row.gross_profit),
      label: 'GP',
      sortable: true,
      align: 'right',
      rowClass: 'text-right text-weight-medium vertical-middle'
    }
  ]
}

export const profitTargetSKUTable = {
  visibleColumns: ['product_full_name', 'gp_type', 'gross_profit'],

  columns: [
    {
      name: 'product_full_name',
      field: (row) =>
        `<div>
          ${row.product_full_name}
          ${
            row.is_waiting_approval
              ? '<span class="custom-badge-blue dense q-ml-sm">Belum Disetujui</span>'
              : ''
          }
        </div>`,
      label: 'SKU',
      sortable: true,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'gp_type',
      field: (row) => {
        const gpType = row.gp_type?.toLowerCase()
        const marginTypeBadge = {
          sub_category: ['custom-badge-purple', 'Kategori 3'],
          brand: ['custom-badge-blue', 'Merek'],
          sku: ['custom-badge-green', 'SKU']
        }[gpType]

        return `<div role="alert" class="${marginTypeBadge[0]} dense">${marginTypeBadge[1]}</div>`
      },
      label: 'Jenis Margin',
      sortable: true,
      align: 'left',
      rowClass: 'text-left vertical-middle'
    },
    {
      name: 'gross_profit',
      field: (row) => renderPercentage(row.gross_profit),
      label: 'GP',
      sortable: true,
      align: 'right',
      rowClass: 'text-right vertical-middle'
    }
  ]
}

export const profitTargetSKUApprovalTable = {
  visibleColumns: ['product_full_name', 'type', 'gross_profit'],

  columns: [
    {
      name: 'product_full_name',
      field: (row) => row.product_full_name,
      label: 'SKU',
      sortable: true,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'type',
      field: (row) => {
        const gpType = row.type?.toLowerCase()
        const marginTypeBadge = {
          sub_category: ['custom-badge-purple', 'Kategori 3'],
          brand: ['custom-badge-blue', 'Merek'],
          sku: ['custom-badge-green', 'SKU']
        }[gpType]

        return `<div role="alert" class="${marginTypeBadge[0]} dense">${marginTypeBadge[1]}</div>`
      },
      label: 'Jenis Margin',
      sortable: true,
      align: 'left',
      rowClass: 'text-left vertical-middle'
    },
    {
      name: 'gross_profit',
      field: (row) => renderPercentage(row.gross_profit),
      label: 'GP',
      sortable: true,
      align: 'right',
      rowClass: 'text-right vertical-middle'
    }
  ]
}

export const profitTargetHistoryTable = {
  visibleColumns: ['processed_at', 'requested_by', 'updated_at', 'approved_by', 'gross_profit', 'notes'],

  columns: [
    {
      name: 'updated_at',
      field: (row) => commonDate({ date: row.updated_at }),
      label: 'Tanggal Diubah',
      sortable: false,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'requested_by',
      field: (row) => renderUser(row.requested_by),
      label: 'Diubah Oleh',
      sortable: false,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'processed_at',
      field: (row) => commonDate({ date: row.processed_at }),
      label: 'Tanggal Disetujui',
      sortable: false,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'approved_by',
      field: (row) => renderUser(row.approved_by),
      label: 'Disetujui Oleh',
      sortable: false,
      align: 'left',
      rowClass: 'text-left text-weight-medium vertical-middle'
    },
    {
      name: 'gross_profit',
      field: (row) => renderPercentage(row.gross_profit),
      label: 'GP',
      sortable: false,
      align: 'right',
      rowClass: 'text-right vertical-middle'
    },
    {
      name: 'notes',
      field: (row) => row.notes,
      label: 'Alasan',
      sortable: false,
      align: 'left',
      rowClass: 'text-left vertical-middle',
      style: 'width: 200px'
    }
  ]
}
